export enum DocumentInstancePermissions {
  GET_DOCUMENT_INSTANCES = 'documentInstance.getDocumentInstances',
  CREATE_DOCUMENT_INSTANCE = 'documentInstance.createDocumentInstance',
  UPDATE_DOCUMENT_INSTANCE = 'documentInstance.updateDocumentInstance',
  ARCHIVE_DOCUMENT_INSTANCE = 'documentInstance.archiveDocumentInstance',
}
